import { render, staticRenderFns } from "./TodayReservation.vue?vue&type=template&id=158e370a"
import script from "./TodayReservation.vue?vue&type=script&lang=js"
export * from "./TodayReservation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports